import React, { ReactNode } from "react";
import styled from "styled-components";
import { StyledLabel, TextFieldWrapper } from "./TextFieldController";
import { Controller } from "react-hook-form";
import { TypographyNew, TextVariant } from "../typography/typography";

const InputWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  width: 295px;
  height: 38px;
`;

const StyledInput = styled.input<{ error: boolean }>`
  width: 225px;
  height: 38px;
  border: 1px solid
    ${(props) =>
      props.error ? props.theme.colors.accent1 : props.theme.colors.grays4};
  border-radius: ${(props) => props.theme.borderRadius.small};
  font-family: ${(props) => props.theme.fonts.normal};
  font-weight: 400;
  font-size: 15px;
  padding-left: 10px;
  outline-color: ${(props) => props.theme.colors.primary1};
  &:hover {
    background: ${(props) => props.theme.colors.misc3};
    cursor: pointer;
  }
  &:focus {
    background: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.grays1};
  }
  &:active {
    border: 1px solid ${(props) => props.theme.colors.primary1};
    background: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.grays1};
  }
`;

interface SliderControlledProps {
  label: string;
  fieldName: string;
  control: any;
  defaultValue: number;
  stepSize: number;
  max: number;
  min: number;
  legend: string;
  className?: string;
  labelComponent?: ReactNode;
}

const SliderControlled = (props: SliderControlledProps): JSX.Element => {
  return (
    <Controller
      name={props.fieldName}
      control={props.control}
      defaultValue={props.defaultValue}
      render={({
        field: { onChange, value, name, ref },
        fieldState: { error },
      }) => {
        const labelChild = props.labelComponent ?? (
          <TypographyNew variant={TextVariant.subtitle2} marginLeft={"auto"}>
            {value} {props.legend}
          </TypographyNew>
        );
        return (
          <TextFieldWrapper className={props.className}>
            <StyledLabel>
              <label>{props.label}</label>
            </StyledLabel>
            <InputWrapper>
              <StyledInput
                error={error !== undefined}
                key={name}
                onChange={onChange}
                ref={ref}
                value={value}
                type={"range"}
                step={props.stepSize}
                max={props.max}
                min={props.min}
                color={"primary"}
              />
              {labelChild}
            </InputWrapper>
          </TextFieldWrapper>
        );
      }}
    />
  );
};

export default SliderControlled;
